import { Dialog, DialogContent } from '@commenda/kakashi';
import React from 'react';

interface FormDialogProps {
  isOpen: boolean;
  setOpen: (open: boolean) => void;
  FormComponent: React.ComponentType<any>;
  formProps?: Record<string, any>;
}

const FormDialog: React.FC<FormDialogProps> = ({
  isOpen,
  setOpen,
  FormComponent,
  formProps = {},
}) => {
  return (
    <Dialog open={isOpen} onOpenChange={setOpen}>
      <DialogContent className="max-h-[85vh] px-0 py-0 overflow-hidden">
        <FormComponent {...formProps} />
      </DialogContent>
    </Dialog>
  );
};

export default FormDialog;
